import { get } from '@/services/API';

export default {
  getUserTenant: () => get('/api/tenant'),
};
